import React, { useState, useEffect } from "react";
import { Row, Col, Card, Typography, message, Divider, List, Space, Alert } from "antd";
import { FormOutlined } from "@ant-design/icons";
import { HeaderPage } from "../../../components/headerPage";
import { HeaderTitle } from "../../../components/headerTitle";
import { useNavigate, useParams } from "react-router-dom";
import ButtonLancamento from "./components/buttonLancamento";
import http from "../../../services/http";
import { RenderAvatar } from "./components/renderImage";
const { Text } = Typography;

export const EleicoesCipaLancamento = ({ to }) => {
  const navigate = useNavigate();
  const { id_eleicoes_lancamento } = useParams();
  const [loading, setLoading] = useState(false);
  const [dados, setDados] = useState([]);

  const [eleicao, setEleicao] = useState({});

  useEffect(() => {
    if (id_eleicoes_lancamento) {
      carregarEleicaoLancamento(id_eleicoes_lancamento);
    }
  }, [id_eleicoes_lancamento]);

  // CARREGAR ELEIÇÃO
  const carregarEleicaoLancamento = async (id) => {
    if (!id) return;
    setLoading(true);
    const api = await http("get", `v1/eleicoes_cipa_lancamento/carregar/${id}`, []);
    if (api.statusCode === 200) {
      const response = api?.response?.data;
      if (!!response) {
        setDados(response?.candidatos);
        setEleicao(response?.eleicao);
      }
    } else {
      navigate(to);
      message.error(api.response.message);
    }
    setLoading(false);
  };

  return (
    <Row align="middle" justify="center" className="content-row">
      <Col span={24} align="middle" justify="center">
        <Col xs={24} sm={24} md={22} lg={22} xl={20} xxl={16} align="left">
          <div className="content-item">
            <HeaderPage title="Eleições CIPA" onClickBack={() => navigate(to)} />
            <HeaderTitle
              title={["Eleições", "Lançamento"]}
              subtitle={eleicao?.eleicao ?? ""}
              icon={<FormOutlined />}
              loading={loading}
            />
            <Divider />

            <Card bordered={false} bodyStyle={{ padding: "3%" }}>
              <Row>
                <Col className="gutter-row" xs={24} sm={24} md={12} lg={12} xl={12} style={{ marginBottom: 20 }}>
                  <Space direction="vertical" size={0}>
                    <Text type="secondary" style={{ fontSize: 16 }}>
                      Eleição
                    </Text>
                    <Text strong style={{ fontSize: 18 }}>
                      {eleicao?.eleicao} - {eleicao?.ano}
                    </Text>
                  </Space>
                </Col>
                <Col className="gutter-row" xs={24} sm={24} md={12} lg={12} xl={12}>
                  <Space direction="vertical" size={0}>
                    <Text type="secondary" style={{ fontSize: 16 }}>
                      Localidade
                    </Text>
                    <Text strong style={{ fontSize: 18 }}>
                      {eleicao?.localidade}
                    </Text>
                  </Space>
                </Col>
              </Row>

              <Alert
                message={<Text strong>Escolha o candidato que deseja, clique em votar e confirme.</Text>}
                type="info"
                showIcon
              />

              <Divider />

              <List
                className="demo-loadmore-list"
                loading={loading}
                pagination={false}
                itemLayout="horizontal"
                dataSource={dados}
                renderItem={(item) => (
                  <List.Item actions={[<ButtonLancamento id={eleicao?.id} nome={item?.nome} idCandidato={item?.id} />]}>
                    <List.Item.Meta
                      avatar={<RenderAvatar idImagem={item?.id} />}
                      title={`${item.nome} ${item.codigo_filial ? `(${item.codigo_filial} - ${item.filial})` : ""}`}
                      description={item?.matricula ?? item?.nome}
                    />
                  </List.Item>
                )}
              />
            </Card>
          </div>
        </Col>
      </Col>
    </Row>
  );
};
